import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { CrudEndpoints, EditorDefinition, Expose, IsSimpleText, IdItemModel, ItemModelDefinition, MinLength, Trim, ItemModelProp, ModelId } from '@core/shared/model';
import { MandatoryCourseGroupRestraints } from './mandatory-course-group.restraints';
let MandatoryCourseGroupItem = /*#__PURE__*/(() => {
  let MandatoryCourseGroupItem = class MandatoryCourseGroupItem extends IdItemModel {
    toString() {
      return "Pflichtkurs-Preset " + this.name;
    }
  };
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], MandatoryCourseGroupItem.prototype, "companyId", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MandatoryCourseGroupItem.prototype, "updateDate", void 0);
  __decorate([MinLength(3), IsSimpleText(), Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], MandatoryCourseGroupItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: []
  }), __metadata("design:type", Array)], MandatoryCourseGroupItem.prototype, "courses", void 0);
  MandatoryCourseGroupItem = __decorate([EditorDefinition('manager', {
    name: true,
    courses: true,
    companyId: 'readonly'
  }, {
    useCrudEndpoint: 'manager'
  }), UseRestraints(MandatoryCourseGroupRestraints), CrudEndpoints({
    manager: '/courses/mandatory-course-groups',
    admin: '/admin/courses/mandatory-course-groups'
  }, {
    clientCache: {
      seconds: 15 * 60,
      clearOnUserChange: true,
      endpoints: {
        manager: true,
        admin: true
      }
    }
  }), ItemModelDefinition({
    texts: {
      item: 'Pflichtkurs-Gruppe',
      items: 'Pflichtkurs-Gruppen'
    }
  }), ModelId("MandatoryCourseGroupItem") // auto-generated by generate-model-ids
  ], MandatoryCourseGroupItem);
  return MandatoryCourseGroupItem;
})();
export { MandatoryCourseGroupItem };